/**
 * @description: 用户管理路由文件
 * @author: lx
 * @Compile：2022-06-02 10：00
 * @update: lx(2022-06-02 10：00)
 */
export default [
  {
    path: "/userInfo",
    component: () => import("../../pages/lookfor/user/userInfo/userInfo.vue"),
    name: "userInfo",
    title: "用户信息管理",
    meta: {
      title: "用户信息管理"
    }
  },
]